import React from "react";
import { FaImage, FaPalette, FaSpinner, FaUpload } from "react-icons/fa";

import { getMediaUrl } from "../utils/parametresUtils";

export default function LogoClubCard({
  settings,
  uploadingLogo,
  onLogoChange,
}) {
  const logoUrl = getMediaUrl(settings.logo_club);

  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none">
      <div>
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-orange-600 dark:text-orange-300">
          Identité visuelle
        </p>
        <h2 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
          Logo du club
        </h2>
        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          Téléversez le logo qui sera utilisé dans l’interface et sur le site.
        </p>
      </div>

      <div className="mt-6 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-950">
        {logoUrl ? (
          <div className="flex min-h-[260px] items-center justify-center p-8">
            <img
              src={logoUrl}
              alt="Logo du club"
              className="max-h-56 max-w-full object-contain"
            />
          </div>
        ) : (
          <div className="flex min-h-[260px] flex-col items-center justify-center p-8 text-slate-400">
            <FaImage className="text-5xl" />
            <p className="mt-3 text-sm font-bold">Aucun logo renseigné</p>
          </div>
        )}
      </div>

      <div className="mt-5">
        <label className="flex cursor-pointer flex-col items-center justify-center rounded-3xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center transition hover:border-orange-300 hover:bg-orange-50/60 dark:border-slate-700 dark:bg-slate-950 dark:hover:border-orange-500/40 dark:hover:bg-orange-500/10">
          {uploadingLogo ? (
            <FaSpinner className="animate-spin text-xl text-orange-500" />
          ) : (
            <FaUpload className="text-xl text-orange-500" />
          )}

          <span className="mt-2 text-sm font-bold text-slate-700 dark:text-slate-200">
            {uploadingLogo ? "Téléversement..." : "Choisir un logo"}
          </span>

          <span className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            PNG, JPG ou WEBP recommandé
          </span>

          <input
            type="file"
            accept="image/*"
            onChange={onLogoChange}
            disabled={uploadingLogo}
            className="sr-only"
          />
        </label>
      </div>

      <div className="mt-5 rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-950">
        <div className="flex items-center gap-3">
          <span
            className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-slate-200 dark:border-slate-700"
            style={{ backgroundColor: settings.primary_color || "#000000" }}
          >
            <FaPalette className="text-white drop-shadow" />
          </span>

          <div>
            <p className="text-sm font-bold text-slate-900 dark:text-white">
              Couleur primaire
            </p>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              {settings.primary_color || "#000000"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}